import * as React from "react";
import {useState} from "react";
import {SliderComponent} from "../../common/Slider.component";

export const OperationalDueDiligenceDisclosure: React.FunctionComponent = () => {
    const [displaySlider, setDisplaySlider] = useState(false);

    const getText = () => {
        return <div className={"odd-disclosure__text"}>
            <div>
                Aon’s Investment Management & Research (“IMR Team”) is focused on identifying investment managers and
                strategies across both traditional and alternative asset classes for clients to use and monitoring
                existing managers in clients’ portfolios. The IMR team conducts ongoing due diligence on existing
                client managers, actively seeks new managers that may have the ability to add value to client
                portfolios and is responsible for issuing recommendations on managers to Aon’s broad client base.
                The IMR Team provides research ratings, selection, and oversight of non-affiliated/third-party
                investment managers for Aon’s global investment consulting practice and its clients according to an
                established, rigorous and independent research process.
            </div>
            <div>
                As part of its qualitative research and evaluation of an investment manager, the IMR Team has an
                agreement with Aon’s operational risk consulting practice, the Operational Risk Solutions and Analytics
                (“ORSA”) Group of Aon Consulting Inc. to provide due diligence reviews assessing an investment
                manager’s non-investment risks relating to its business structure, activities, operations, and
                compliance practices. Overall Buy and Sell ratings may only be assigned from qualitative research, and
                each manager must pass the quantitative operational due diligence (“ODD”) process to receive a “Buy”
                rating. Operational due diligence services are provided by Aon’s Operational Risk Solutions and
                Analytics Group, which is an independent entity.
            </div>
        </div>;
    };

    return <div className={"odd-disclosure__container"}>
        <div className={"odd-disclosure__link"} onClick={() => setDisplaySlider(true)} data-testid="odd-disclosure__link">
            Disclosure
        </div>
        <SliderComponent
            hideSlider={() => setDisplaySlider(false)}
            header="Operational Due Diligence"
            content={getText()}
            display={displaySlider}/>
    </div>;
};

